import React from 'react';
import { injectIntl } from 'gatsby-plugin-intl';

import UlList from './styledComponents/UlList';
import H3 from './styledComponents/H3';
import H4 from './styledComponents/H4';
import SubTitle from './styledComponents/SubTitle';
import Paragraph from './styledComponents/Paragraph';
import RuleDescription from './styledComponents/RuleDescription';
import IdeaGeneral from './styledComponents/IdeaGeneral';
import ChapterSpace from './styledComponents/ChapterSpace';

import PlainImage from './imageComponents/PlainImage';

import { Container,Cell,Grid,AnchorBlock,ChapterHeader,ParentAnchor } from './blockComponents';
import { ImageMultilang } from './utility/imageMultilang';

function Brand({ 
    intl,
    activeAnchor,
    setActiveAnchor,
    pageHeight,
    refs
    }) {
        
    return (
        <ParentAnchor
            key='brandSection'
            blockId="brand-section"
            blockName='brandSection'
            refs={refs}>
            <ChapterHeader title={intl.formatMessage({ id: 'brand_title' })}></ChapterHeader>
            <Container>
                <Grid>
                    <Cell col={12} colXl={10} colXxl={8} leftXl={2} leftXxl={3}>
                        <AnchorBlock
                            key='mentionBrandBlock'
                            blockName='mentionBrandBlock'
                            blockId='mention-brand'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'brand_1_1' })}</H3>
                            <SubTitle space="Down">{intl.formatMessage({ id: 'brand_1_2' })}</SubTitle>
                            {intl.formatMessage({ id: 'brand_1_3' })}<br />
                            {intl.formatMessage({ id: 'brand_1_4' })}<br />
                            {intl.formatMessage({ id: 'brand_1_5' })}
                        </AnchorBlock>

                        <AnchorBlock
                            key='differentiateBrandBlock'
                            blockName='differentiateBrandBlock'
                            blockId='differentiate-brand'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'brand_2_1' })}</H3>
                            <Paragraph space="Down">{intl.formatMessage({ id: 'brand_2_1_1' })}</Paragraph>
                            <Paragraph>{intl.formatMessage({ id: 'brand_2_1_2' })}</Paragraph>
                            <Paragraph>{intl.formatMessage({ id: 'brand_2_1_3' })}</Paragraph>

                            <H4 space="TopDown">{intl.formatMessage({ id: 'brand_2_4' })}</H4>
                            <UlList>
                                <li>{intl.formatMessage({ id: 'brand_2_4_1' })}</li>
                                <li>{intl.formatMessage({ id: 'brand_2_4_2' })}</li>
                                <li>{intl.formatMessage({ id: 'brand_2_4_3' })}</li>
                                <li>{intl.formatMessage({ id: 'brand_2_4_4' })}</li>
                            </UlList>
                            <Paragraph space="Top">{intl.formatMessage({ id: 'brand_2_5' })}</Paragraph>
                            <Paragraph>{intl.formatMessage({ id: 'brand_2_6' })}</Paragraph>

                            <H4 space="TopDown">{intl.formatMessage({ id: 'brand_2_7' })}</H4>
                            <Grid>
                                <Cell col={12} colSm={6}>
                                    <RuleDescription />
                                    <ImageMultilang 
                                        intl={intl} 
                                        last="sm"
                                        imageRu='brand/brand_5.1-ru@2x.png'
                                        imageUk='brand/brand_5.1-uk@2x.png'
                                        imageEn='brand/brand_5.1-en@2x.png'/>
                                </Cell>
                                <Cell col={12} colSm={6}>
                                    <RuleDescription rule="do" />
                                    <ImageMultilang 
                                        intl={intl} 
                                        last="sm"
                                        imageRu='brand/brand_5.2-ru@2x.png'
                                        imageUk='brand/brand_5.2-uk@2x.png'
                                        imageEn='brand/brand_5.2-en@2x.png'/>
                                </Cell>
                            </Grid>

                            <H4 space="TopDown">{intl.formatMessage({ id: 'brand_2_8' })}</H4>
                            <Paragraph space="Down">{intl.formatMessage({ id: 'brand_2_9' })}</Paragraph>
                            <Paragraph space="Down">{intl.formatMessage({ id: 'brand_2_10' })}</Paragraph>
                            <Grid>
                                <Cell col={12} colSm={6}>
                                    <RuleDescription />
                                    <PlainImage src="brand/brand_3@2x.jpg" last="sm" alt="" />
                                </Cell>
                                <Cell col={12} colSm={6}>
                                    <RuleDescription rule="do" />
                                    <PlainImage src="brand/brand_2@2x.jpg" last="xs" alt="" />
                                </Cell>
                            </Grid>

                            <H4 space="TopDown">{intl.formatMessage({ id: 'brand_2_11' })}</H4>
                            <Grid>
                                <Cell col={12} colSm={6}>
                                    <RuleDescription />
                                    <ImageMultilang 
                                        intl={intl} 
                                        last="sm"
                                        imageRu='brand/brand-4.1-ru@2x.jpg'
                                        imageUk='brand/brand-4.1-uk@2x.jpg'
                                        imageEn='brand/brand-4.1-en@2x.jpg'/>
                                </Cell>
                                <Cell col={12} colSm={6}>
                                    <RuleDescription rule="do" />
                                    <ImageMultilang 
                                        intl={intl} 
                                        last="xs"
                                        imageRu='brand/brand-4.2-ru@2x.jpg'
                                        imageUk='brand/brand-4.2-uk@2x.jpg'
                                        imageEn='brand/brand-4.2-en@2x.jpg'/>
                                </Cell>
                            </Grid>

                            <H4 space="TopDown">{intl.formatMessage({ id: 'brand_2_12' })}</H4>
                            <div>
                                <RuleDescription rule="do">{intl.formatMessage({ id: 'brand_2_13' })}</RuleDescription>
                                <ImageMultilang 
                                        intl={intl} 
                                        last="xs"
                                        imageRu='brand/status-ok-ru@2x.jpg'
                                        imageUk='brand/status-ok-uk@2x.jpg'
                                        imageEn='brand/status-ok-en@2x.jpg'/>
                            </div>
                            <div>
                                <RuleDescription space="TopDown">{intl.formatMessage({ id: 'brand_2_14' })}</RuleDescription>
                                <ImageMultilang 
                                        intl={intl} 
                                        last="xs"
                                        imageRu='brand/status-notok-ru@2x.jpg'
                                        imageUk='brand/status-notok-uk@2x.jpg'
                                        imageEn='brand/status-notok-en@2x.jpg'/>
                            </div>

                            <H4 space="TopDown">{intl.formatMessage({ id: 'brand_2_18' })}</H4>
                            <Paragraph space="Down">{intl.formatMessage({ id: 'brand_2_19' })}</Paragraph>
                            <Paragraph space="Down">{intl.formatMessage({ id: 'brand_2_20' })}</Paragraph>

                            <H4 space="TopDown">{intl.formatMessage({ id: 'brand_2_22' })}</H4>
                            <Paragraph>{intl.formatMessage({ id: 'brand_2_23' })}</Paragraph>
                            <Paragraph>{intl.formatMessage({ id: 'brand_2_24' })}</Paragraph>

                            <H4 space="TopDown">{intl.formatMessage({ id: 'brand_2_25' })}</H4>
                            <Paragraph>{intl.formatMessage({ id: 'brand_2_26' })}</Paragraph>

                            <H4 space="TopDown">{intl.formatMessage({ id: 'brand_2_27' })}</H4>
                            <IdeaGeneral>{intl.formatMessage({ id: 'brand_2_28' })}</IdeaGeneral>

                        </AnchorBlock>
                    </Cell>
                </Grid>
            </Container>
            <ChapterSpace />
        </ParentAnchor>
        
    )
}

export default injectIntl(Brand)